/* eslint-disable no-nested-ternary */
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Webcam from 'react-webcam';
import IcomoonReact from 'icomoon-react';
import ReactPlayer from 'react-player';

import Spinner from '../../../../../shared/components/Spinner/Spinner';
import Text from '../../../../../shared/components/Text/Text';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import NoHoverButton from './NoHoverButton';
import {
  setQuickVideoWorkoutsJournalModal,
  uploadQuickJournalMedia,
} from '../../../ducks/workoutsActions';

const ModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  .modal-button {
    align-items: center;
    background: '#ff6600';
    color: white!important;
  }
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const InnerWrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  .modal-button {
    align-items: center;
    background: '#ff6600';
  }
`;

const AnotherWrapper = styled('div')`
  position: relative;
`;

const NavigationWrapper = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: -20px;
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 20px;
  margin-bottom: 30px;

  .arrow-div {
    cursor: pointer;

    &.back {
      justify-self: flex-start;
    }
    &.close {
      justify-self: flex-end;
      margin-left: auto;
    }
  }
`;

const WebcamContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text {
    font-size: 26px;
    font-weight: 300;
  }
  .capture-button {
    width: 180px;
    background-color: ${(props) => props.theme.colors.green};
    color: white;

    &:hover {
      opacity: .7;
    }
  }
`;

const SpinnerWrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
  `;

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: 'user',
};

const WebcamCaptureQuickVideo = () => {
  const dispatch = useDispatch();
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [capturing, setCapturing] = useState(false);
  const [isCaptured, setIsCaptured] = useState(false);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const uploadedWorkoutsMedia = useSelector((state) => state.workouts.data.uploadedWorkoutsMedia);
  const uploadedWorkoutJournalMediaObject = useSelector(
    (state) => state.workouts.data.uploadedWorkoutJournalMediaObject,
  );

  const handleDataAvailable = ({ data }) => {
    if (data.size > 0) {
      setIsCaptured(true);
      setCapturing(false);
      const file = new File([data], 'mkv', {
        type: 'video/mkv',
      });
      const fileArray = [file];
      const type = fileArray[0].type.split('/').shift();
      dispatch(uploadQuickJournalMedia(
        { accountCode: currentUser.accountCode, acceptedFile: fileArray, type },
      ));
    }
  };

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream);
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable,
    );
    mediaRecorderRef.current.start();
  }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
  }, [mediaRecorderRef, webcamRef, setCapturing]);

  const buttonMasher = () => {
    if (!isCaptured) {
      if (capturing) {
        return (
          <NoHoverButton
            className='modal-button'
            onClick={handleStopCaptureClick}
            cta='Stop Capture'
            customColor='#10cd8c'
            noHover
            noBorder
            bottom
            fullWidth
            large
            primary
            square
          />
        );
      }
      return (
        <NoHoverButton
          className='modal-button'
          onClick={handleStartCaptureClick}
          cta='Start Capture'
          customColor='#10cd8c'
          noHover
          noBorder
          bottom
          fullWidth
          large
          primary
          square
        />
      );
    }
    return (
      <NoHoverButton
        bottom
        fullWidth
        cta='Done'
        customColor='#10cd8c'
        className='modal-button'
        onClick={() => dispatch(setQuickVideoWorkoutsJournalModal(false))}
        large
        noBorder
        primary
        square
        noHover
      />
    );
  };

  const playerMasher = () => {
    if (isCaptured) {
      if ((Object.keys(uploadedWorkoutsMedia).length
      && uploadedWorkoutsMedia.mediaUrl)
      || (Object.keys(uploadedWorkoutJournalMediaObject).length
      && uploadedWorkoutJournalMediaObject.mediaUrl)) {
        return (
          <ReactPlayer
            src={uploadedWorkoutsMedia.mediaUrl || uploadedWorkoutJournalMediaObject.mediaUrl}
            controls
            width='100%'
            height='100%'
          />
        );
      }
      return (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      );
    }
    return (
      <Webcam
        width='100%'
        height='100%'
        ref={webcamRef}
        videoConstraints={videoConstraints}
      />
    );
  };

  return (
    <ModalWrapper>
      <NavigationWrapper>
        <Text
          className='close arrow-div'
          onClick={() => {
            dispatch(setQuickVideoWorkoutsJournalModal(false));
          }}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={13}
            icon='remove'
            color='white'
          />
        </Text>
      </NavigationWrapper>
      <InnerWrapper>
        <AnotherWrapper>
          <WebcamContainer>
            {playerMasher()}
            {buttonMasher()}
          </WebcamContainer>
        </AnotherWrapper>
      </InnerWrapper>
    </ModalWrapper>
  );
};

WebcamCaptureQuickVideo.propTypes = {

};

export default WebcamCaptureQuickVideo;
